import { render } from "./UpdateProfile.vue?vue&type=template&id=98e17676&scoped=true"
import script from "./UpdateProfile.vue?vue&type=script&lang=js"
export * from "./UpdateProfile.vue?vue&type=script&lang=js"

import "./UpdateProfile.vue?vue&type=style&index=0&id=98e17676&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98e17676"]])

export default __exports__